import { Box, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { uniTypography } from '@src/fonts/typography/uniTypography';

export const SecurePurchaseRoot = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: uni('scale-200'),
  color: uni('fg-success-default-rest'),
  '& svg': {
    display: 'block',
    flexShrink: 0,
  },
}));

export const SecurePurchaseLabel = styled('span')`
  ${uniTypography('text-md', 'medium')}
  color: ${uni('fg-success-default-rest')};

  [data-size='lg'] & {
    ${uniTypography('text-lg', 'medium')}
  }
`;
